import React from "react";
import Icon from "../../../components/Icon";
import styles from "../Front.module.sass";
import cusHomePage from "../../../i11/CustomizeHomePage";

import { Link } from "react-router-dom";
import { useUser } from "../../../context";

const BrandBoxFooter = () => {
	const { locale } = useUser();

	return (
		<div className={styles.footer}>
			<div className={styles.footerItem}>
				<img
					src={"/apple-touch-icon.png"}
					alt="__logo__"
					className={styles.meteriumLogo}
					loading="lazy"
				/>
				<div className={styles.row_item}>
					<div className={styles.about}>
						<h3>{cusHomePage[locale].about}</h3>
						<Link className={styles.lk} to="/customize/token-store">
							{cusHomePage[locale].token_store}
						</Link>
						<Link
							className={styles.lk}
							to="/customize/com-marketplace"
						>
							{cusHomePage[locale].com_marketplace}
						</Link>
						<Link className={styles.lk} to="#">
							{cusHomePage[locale].login}
						</Link>
						<Link className={styles.lk} to="#">
							{cusHomePage[locale].sign_up}
						</Link>
					</div>
					<div className={styles.about}>
						<h3>{cusHomePage[locale].legal}</h3>
						<Link
							className={styles.lk}
							to="/settings/privacy-policy"
						>
							{cusHomePage[locale].privacy_policy}
						</Link>
						<Link
							className={styles.lk}
							to="/settings/privacy-policy"
						>
							{cusHomePage[locale].term_conditions}
						</Link>
					</div>
					<div className={styles.about}>
						<h3>{cusHomePage[locale].social_media}</h3>
						<Link to="/settings/social-links" className={styles.lk}>
							<div className={styles.socialIcon}>
								<Icon name="instagram" size={32} fill="white" />
								<Icon
									reicon="facebook"
									size={32}
									fill="white"
								/>
							</div>
							<div className={styles.socialIcon}>
								<Icon reicon="discord" size={32} fill="white" />
								<Icon reicon="twitter" size={32} fill="white" />
							</div>
						</Link>
					</div>
				</div>
			</div>
			<div className={styles.divider} />

			<div className={styles.copyright}>
				N-Finite ©{new Date().getFullYear()}
			</div>
		</div>
	);
};

export default BrandBoxFooter;
